import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EmptyState from '@/components/common/EmptyState.jsx';
import { etiquetasEmitidas } from '@/services/etiquetas.js';
import {
  CargasPage,
  CargasSection,
  CargasStickyActions,
  CargasTableShell,
  CargasViewport,
  cargasButtonClassName,
  cargasPrimaryButtonClassName,
} from './components/CargasLayout.jsx';

function downloadZpl(codigo, zpl) {
  if (!zpl) return;
  const blob = new Blob([zpl], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${codigo}.zpl.txt`;
  link.click();
  URL.revokeObjectURL(url);
}

export default function RecepcionDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [etiquetas, setEtiquetas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    etiquetasEmitidas({ recepcionId: id }, { page: 1, pageSize: 50 })
      .then(data => setEtiquetas(data.items || []))
      .catch(err => setError(err.message || 'No se pudieron cargar las etiquetas.'))
      .finally(() => setLoading(false));
  }, [id]);

  // New labels belong to new remitos of this reception; existing labels are reprinted
  // from the label list, never re-emitted (that would duplicate bultos).
  const handleEmitir = () => {
    navigate('/cargas/etiquetas/nueva', { state: { prefill: { recepcionId: id } } });
  };

  return (
    <CargasPage
      title={`Recepcion ${id}`}
      description="Detalle operativo de la recepcion y acceso rapido a la emision de etiquetas."
      hideHeaderOnCompact
      footer={
        <CargasStickyActions
          summary={<div className="text-xs text-[rgba(var(--muted),0.92)]">Etiquetas cargadas: {etiquetas.length}</div>}
          actions={
            <>
              <button type="button" className={cargasButtonClassName} onClick={() => navigate('/cargas/recepcion')}>
                Volver
              </button>
              <button type="button" className={cargasPrimaryButtonClassName} onClick={handleEmitir}>
                Emitir etiquetas
              </button>
            </>
          }
        />
      }
    >
      <CargasViewport>
        <CargasSection title="Etiquetas emitidas" bodyClassName="min-h-0 p-4">
          {loading ? <p className="text-sm text-[rgba(var(--muted),0.9)]">Cargando...</p> : null}
          {error ? <p className="text-sm text-[rgb(var(--brand))]">{error}</p> : null}
          {!loading && etiquetas.length === 0 ? (
            <EmptyState title="Sin etiquetas" description="No hay etiquetas asociadas a esta recepcion." />
          ) : null}
          {etiquetas.length > 0 ? (
            <CargasTableShell className="max-h-[300px]">
              <table className="min-w-full text-left text-sm">
                <thead className="sticky top-0 bg-[rgb(var(--panel))]">
                  <tr>
                    <th className="px-3 py-2">Etiqueta</th>
                    <th className="px-3 py-2">Servicio</th>
                    <th className="px-3 py-2">Bultos</th>
                    <th className="px-3 py-2">Estado</th>
                    <th className="px-3 py-2 text-right">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {etiquetas.map(row => (
                    <tr key={row.id} className="border-t border-[rgba(var(--border),0.45)]">
                      <td className="px-3 py-2 font-semibold">{row.codigoEtiqueta}</td>
                      <td className="px-3 py-2">{row.servicioDesc}</td>
                      <td className="px-3 py-2">{row.totBultos}</td>
                      <td className="px-3 py-2">{row.estado}</td>
                      <td className="px-3 py-2 text-right">
                        <button
                          type="button"
                          className={cargasButtonClassName}
                          onClick={() => downloadZpl(row.codigoEtiqueta, row.zpl)}
                        >
                          Descargar ZPL
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CargasTableShell>
          ) : null}
        </CargasSection>
      </CargasViewport>
    </CargasPage>
  );
}
